import { makeLazy } from "lib/make-lazy"
import { bind } from "lib/@components/binding/bind"

// ----------------------------------------------------------------------
export const Editor = makeLazy(() => import("./jodit-editor"))

export const BoundTextEditor = bind(<Editor />, { extract: (v) => v })
